const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_cognito_identity_pool_id: 'us-east-1:68274f27-93c2-4e6d-923e-c5bf5d871899',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_xQWgJVuhP',
  aws_user_pools_web_client_id: '274favl87h9f1v3c2sllmreu40',
  oauth: {},
};

export default awsmobile;
